import { Popover, FloatButton, Button } from "antd";
import React from "react";
import { ShareAltOutlined, DownloadOutlined } from "@ant-design/icons";
import downloadjs from 'downloadjs';
import * as htmlToImage from 'html-to-image';

import {
  TwitterShareButton,
  XIcon, 
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  PinterestShareButton,
  PinterestIcon, 
  RedditShareButton,
  RedditIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";

const ShareButton = ({name = "name"}) => {
  const downloadImage = async () => {
    htmlToImage.toCanvas(document.getElementById('fullView'))
      .then(function (canvas) {
        const nameLetters = document.getElementById('nameLetters')
        const boundingBox = nameLetters.getBoundingClientRect()
        const margin = 100
        const boundingBoxMargin = {
          top: boundingBox.top - margin,
          right: boundingBox.right + margin,
          bottom: boundingBox.bottom + margin + 30,
          left: boundingBox.left - margin,
          width: boundingBox.width + margin * 2,
          height: boundingBox.height + margin * 2.15
        }

        const ratio = window.devicePixelRatio;
        const ctx = canvas.getContext("2d");
        const imageData = ctx.getImageData(boundingBoxMargin.left*ratio, boundingBoxMargin.top*ratio, boundingBoxMargin.width*ratio, boundingBoxMargin.height*ratio);
        
        canvas.width = boundingBoxMargin.width * ratio;
        canvas.height = boundingBoxMargin.height * ratio;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.putImageData(imageData, 0, 0);

        const image = canvas.toDataURL("image/png");
        downloadjs(image, `${name}.png`, 'image/png');
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
  }
  return (
    <>
      <Popover
        placement="left"
        content={
          <div>
            <div style={{ display: "flex", alignItems: "center"}}>
              <TwitterShareButton style={{marginRight: 6}} title="See how trendy your name has been over time! Turn name popularity into a fun, shareable visual. 👶📈" url="baby-names.jetpack.ai"><XIcon size={32} round="true" /> </TwitterShareButton>
              <FacebookShareButton style={{marginRight: 6}} quote="See how trendy your name has been over time! Turn name popularity into a fun, shareable visual. 👶📈" url="baby-names.jetpack.ai"><FacebookIcon size={32} round="true" /> </FacebookShareButton>
              <LinkedinShareButton style={{marginRight: 6}} summary="See how trendy your name has been over time! Turn name popularity into a fun, shareable visual. 👶📈" url="baby-names.jetpack.ai"><LinkedinIcon size={32} round="true" /> </LinkedinShareButton>
              <PinterestShareButton style={{marginRight: 6}} description="See how trendy your name has been over time! Turn name popularity into a fun, shareable visual. 👶📈" media="baby-names.jetpack.ai/babyname.png" url="baby-names.jetpack.ai"><PinterestIcon size={32} round="true" /> </PinterestShareButton>
              <RedditShareButton title="See how trendy your name has been over time! Turn name popularity into a fun, shareable visual. 👶📈" url="baby-names.jetpack.ai"><RedditIcon size={32} round="true" /> </RedditShareButton>
              {/* <WhatsappShareButton title="See how trendy your name has been over time! Turn name popularity into a fun, shareable visual. 👶📈" url="baby-names.jetpack.ai"><WhatsappIcon size={32} round="true" /> </WhatsappShareButton> */}
            </div>
            <div>
              <span style={{ marginRight: 8}}><Button shape="round" icon={<DownloadOutlined />} onClick={downloadImage} >Download the image</Button> </span>
            </div>
          </div>
        }
      >
        <FloatButton icon={<ShareAltOutlined />} />
      </Popover>
    </>
  );
};

export default ShareButton;
